<template>
<div class="MEnterpriseEstimation">
    <Header></Header>
    <div class="content_warp">
        <div class="top_box">
            <p class="p_title">企业估值工具</p>
            <p class="p_desc">在线智能估值工具，1分钟免费快速生成估值报告</p>
            <button @click="FreeValuationBtn" class="btn">免费估值</button>
        </div>
        <div class="qygz_box">
            <img class="inset_img" :src="require('@/common/images/gujing/gz/icon-1.png')" alt="企业估值">
            <div class="explain_box">
                <p class="title_text">企业估值</p>
                <p class="desc_text">企业估值是企业资本运营决策的重要基础和灵魂，股鲸估值工具依托互联网、大数据和人工智能技术，协助企业家更好的理解估值逻辑、运用好估值模型，快速生成企业估值报告，为企业的并购重组、股权融资、股权激励等提供依据。</p>
            </div>
        </div>
        <div class="zyznh_box">
            <img class="inset_img" :src="require('@/common/images/gujing/gz/icon-2.png')" alt="企业估值">
            <div class="explain_box">
                <p class="title_text">专业智能化的估值技术</p>
                <div class="list_box">
                    <div class="list_item">
                        <img :src="require('@/common/images/gujing/gz/icon-gz1.png')" alt="">
                        <div class="right_box">
                            <p>考虑行业特性</p>
                            <p>估值方法充分考虑行业特性，根据A股分类采集行业数据</p>
                        </div>
                    </div>
                    <div class="list_item">
                        <img :src="require('@/common/images/gujing/gz/icon-gz2.png')" alt="">
                        <div class="right_box">
                            <p>多样化选择</p>
                            <p>多种估值方法供客户选择</p>
                        </div>
                    </div>
                    <div class="list_item">
                        <img :src="require('@/common/images/gujing/gz/icon-gz3.png')" alt="">
                        <div class="right_box">
                            <p>自动识别匹配</p>
                            <p>根据企业所处行业特性，及企业自身特征自动匹配估值方法</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="gums_box">
            <div class="mx_box">
                <p class="title_text">六大估值模型</p>
                <div class="content_div1">
                    <div class="mx_item" v-for="(item, index) in gzmxData" :key="index">
                        <img :src="require('@/common/images/gujingimgs/icon2.png')" alt="">
                        <span>{{item}}</span>
                    </div>
                </div>
            </div>
            <div class="kxwd_box">
                <p class="title_text">三大科学维度</p>
                <div class="content_div2">
                    <div class="kxwd_item" v-for="(item, index) in kxwdData" :key="index">
                        <img :src="require('@/common/images/gujingimgs/icon1.png')" alt="">
                        <p>{{item.name}}</p>
                        <span>{{item.desc}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
    <transition name="slide-fade">
        <img class="gotop_img" @click="goTop" v-show="show" :src="require('@/common/images/gujingimgs/go_top.png')" alt="">
    </transition>
</div>
</template>

<script>
import Header from 'views/gjMobile/components/Header'
import Footer from 'views/gjMobile/components/Footer'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'MEnterpriseEstimation',
    data() {
        return {
            show: false,
            gzmxData: ['市盈率估值法', '市净率估值法', '现金流折现法', '基于运营数据估值', '博克斯模型', '上市逆推法'],
            kxwdData: [
                {
                    name: '估值使用用途',
                    desc: '股权激励、股权融资、并购'
                },
                {
                    name: '企业所处行业',
                    desc: '重资产、轻资产、互联网新经济'
                },
                {
                    name: '企业发展阶段',
                    desc: '初创期、成长期、成熟期'
                }
            ]
        }
    },
    created() {
        // 判断是移动端还是PC端 并跳转到相应页面
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'EnterpriseEstimation'
            })
        }
    },
    activated() {
        $('html,body').animate({scrollTop:'0px'},0)
    },
    mounted() {
        $('html,body').animate({scrollTop:'0px'},0)
        let _this = this
        $(window).scroll(function () {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            let clientHeight = document.body.clientHeight / 2
            if(scrollTop >= clientHeight){
                _this.show = true
            }
            else{
                _this.show = false
            }
        })
    },
    methods: {
        // 免费估值按钮
        FreeValuationBtn() {
            if (this.user.isLogin) {
                // 跳转到估值页面
                this.$router.push({name: 'MEstimationStep'})
            } else {
                // 登录页面
                this.$router.push({name: 'MLogin'})
            }
        },
        // 回到顶部
        goTop() {
            $('html,body').animate({scrollTop:'0px'},300)
            // document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    components: {Header,Footer}
}
</script>

<style lang="scss" type="text/scss">
@import "~common/scss/index";
.MEnterpriseEstimation {
    position: relative;
    background-color: #F5F7FA;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family:PingFangSC-Medium,PingFang SC;
    .content_warp {
        flex: 1;
        padding-bottom: 0.2rem;
        .top_box {
            height: 5.6rem;
            background: url('../../../common/images/gujingimgs/intro-bg.png') no-repeat center;
            background-size: 100% 100%;
            color: #FFF;
            padding: 0 0.32rem;
            padding-top: 1.6rem;
            box-sizing: border-box;
            .p_title {
                font-size: 0.48rem;
                line-height: 0.68rem;
                font-weight: bold;
            }
            .p_desc {
                margin: 0.4rem 0;
                font-size: 0.3rem;
                line-height: 0.46rem;
            }
            .btn {
                width: 2.2rem;
                height: 0.6rem;
                font-size: 0.28rem;
                background:linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                border: none;
                border-radius: 0.3rem;
            }
        }
        .qygz_box, .zyznh_box {
            background-color: #fff;
            padding-top: 0.5rem;
            padding-bottom: 0.48rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            .inset_img {
                width: 3.46rem;
                height: 2.58rem;
                margin-bottom: 0.9rem;
            }
            .explain_box {
                width: 100%;
                box-sizing: border-box;
                padding: 0 0.32rem;
                .title_text {
                    font-size: 0.36rem;
                    line-height: 0.5rem;
                    font-weight: bold;
                    position: relative;
                    margin-bottom: 0.12rem;
                    &::before {
                        content: '';
                        position: absolute;
                        bottom: -0.12rem;
                        width:0.36rem;
                        height:0.04rem;
                        background: #409EFF;
                    }
                }
                .desc_text {
                    font-size: 0.28rem;
                    color: #666;
                    line-height: 0.52rem;
                    padding: 0.48rem 0;
                }
            }
        }
        .zyznh_box {
            padding-top: 0.34rem;
            background-color: #F5F7FA;
            .inset_img {
                width: 3.85rem;
                height: 3.08rem;
                margin-bottom: 0.66rem;
            }
            .list_box {
                margin-top: 0.32rem;
                padding: 0.48rem 0;
                .list_item {
                    display: flex;
                    align-items: center;
                    margin-top: 0.86rem;
                    &>img {
                        width: 0.82rem;
                        height: 0.82rem;
                        margin-right: 0.24rem;
                    }
                    .right_box {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        &>p:nth-of-type(1){
                            font-size: 0.32rem;
                            line-height:0.6rem;
                            margin-bottom: 0.12rem;
                        }
                        &>p:nth-of-type(2){
                            color: #666;
                            font-size: 0.22rem;
                            line-height:0.4rem;
                        }
                    }
                }
                .list_item:nth-of-type(1) {
                    margin-top: 0;
                }
            }
        }
        .gums_box {
            background-color: #fff;
            padding: 0.6rem 0.32rem;
            padding-bottom: 0.4rem;
            .mx_box, .kxwd_box {
                box-shadow:0 0.2rem 0.6rem 0.1rem rgba(13,37,62,0.05);
                border:0.01rem solid rgba(238,238,238,1);
                .title_text {
                    background-color: #1E88F5;
                    height: 0.8rem;
                    line-height: 0.8rem;
                    text-align: center;
                    font-size: 0.32rem;
                    color: #fff;
                    font-weight: bold;
                }
                .content_div1 {
                    padding: 0.6rem 0.24rem;
                    padding-top: 0;
                    display: flex;
                    flex-wrap: wrap;
                    .mx_item {
                        margin-top: 0.6rem;
                        display: flex;
                        align-items: center;
                        width: 50%;
                        &>img {
                            width: 0.4rem;
                            height: 0.4rem;
                            margin-right: 0.2rem;
                        }
                        &>span {
                            font-size: 0.28rem;
                            font-weight: bold;
                        }
                    }
                }
            }
            .kxwd_box {
                margin-top: 0.6rem;
                .title_text{
                    background:rgba(255,199,91,1);
                }
                .content_div2 {
                    padding: 0.6rem 0.24rem;
                    padding-top: 0;
                    .kxwd_item {
                        margin-top: 0.6rem;
                        display: flex;
                        align-items: center;
                        &>img {
                            width: 0.4rem;
                            height: 0.4rem;
                            margin-right: 0.2rem;
                        }
                        &>p{
                            font-size: 0.28rem;
                            font-weight: bold;
                            line-height: 0.3rem;
                            margin-right: 0.4rem;
                        }
                        &>span {
                            font-size: 0.24rem;
                            line-height: 0.3rem;
                        }
                    }
                }
            }
        }
    }
    .gotop_img {
        width: 1.16rem;
        height: 1.16rem;
        position: fixed;
        right: 0.2rem;
        bottom: 1rem;
        opacity: 1;
    }
}
.slide-fade-enter-active, .slide-fade-leave-active {
    transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to{
    opacity: 0;
}
</style>